module.exports = __webpack_public_path__ + "img/PrintPdfFailed.453ca90d.png";